var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_687_552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.662 5.65605C21.8986 5.99374 21.089 6.21552 20.26 6.31405C21.1337 5.79148 21.7877 4.96906 22.1 4.00005C21.28 4.48805 20.381 4.83005 19.444 5.01505C18.8146 4.34163 17.9804 3.89501 17.0709 3.74463C16.1615 3.59425 15.2279 3.74854 14.4153 4.1835C13.6026 4.61846 12.9564 5.30973 12.5771 6.14984C12.1978 6.98995 12.1067 7.93183 12.318 8.82905C10.6551 8.7457 9.02832 8.31357 7.54328 7.56071C6.05823 6.80785 4.74812 5.7511 3.69799 4.45905C3.32628 5.0975 3.13095 5.82328 3.13199 6.56205C3.13199 8.01205 3.86999 9.29305 4.99199 10.043C4.328 10.0221 3.67862 9.84283 3.09799 9.52005V9.57205C3.09819 10.5377 3.43236 11.4737 4.04384 12.2211C4.65532 12.9686 5.50647 13.4815 6.45299 13.673C5.83661 13.8401 5.1903 13.8647 4.56299 13.745C4.82986 14.5763 5.35 15.3032 6.05058 15.8242C6.75117 16.3451 7.59712 16.6338 8.46999 16.65C7.60247 17.3314 6.60917 17.835 5.54687 18.1322C4.48458 18.4294 3.37412 18.5143 2.27899 18.382C4.19069 19.6115 6.41609 20.2642 8.68899 20.262C16.382 20.262 20.589 13.889 20.589 8.36205C20.589 8.18205 20.584 8.00005 20.576 7.82205C21.3949 7.23022 22.1016 6.49707 22.663 5.65705L22.662 5.65605Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_687_552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f75b4e681b90d832882ca34e3da34169.svg";
export { ForwardRef as ReactComponent };